import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  details: {},
  addressSaved: false,
  error: null,
  createRoomDetails: {},
  alreadyHasAddress: false,
  roomCreated: false,
  roomJoinDetails: {},
  roomJoined: false,
  roomAssigned: false,
  userRoomDetails: {},
  joiningRoomDetails: {},
  joinedMemberDetails: [],
  assignedUserDetails: {},
  roomSantaRevealed: {},
  errorMsg: "",
  isAddressSavedToUSerAccount: false,
  isLoading: true,
};

export const SecretSantaSlice = createSlice({
  name: "SecretSantaSlice",
  initialState,
  reducers: {
    requestToCreateRoom: (state) => {
      return {
        ...state,
        errorMsg: "",
      };
    },
    responseToCreateRoom: (state) => {
      return {
        ...state,
        roomCreated: true,
        errorMsg: "",
      };
    },
    requestToSaveAddress: (state) => {
      return {
        ...state,
        errorMsg: "",
      };
    },
    requestToJoinRoom: (state) => {
      return {
        ...state,
        errorMsg: "",
      };
    },
    requestToFailedJoinRoom: (state, action) => {
      return {
        ...state,
        errorMsg: action?.payload,
      };
    },
    requestToFetchUserAddress: (state) => {
      return {
        ...state,
      };
    },
    requestToFetchAssignedUserDetails: (state) => {
      return {
        ...state,
      };
    },
    requestToAddNewAddressToUser: (state) => {
      return {
        ...state,
      };
    },
    responseFromAddNewAddressToUser: (state) => {
      return {
        ...state,
        isAddressSavedToUSerAccount: true,
      };
    },
    responseToJoinRoom: (state) => {
      return {
        ...state,
        roomJoined: true,
      };
    },
    requestToFetchRoomInfo: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    requestToAssignRoom: (state) => {
      return {
        ...state,
      };
    },
    responseFromAssignRoom: (state) => {
      return {
        ...state,
        roomAssigned: true,
      };
    },
    responseToFetchRoomInfo: (state, action) => {
      return {
        ...state,
        userRoomDetails: action?.payload,
        isLoading: false,
      };
    },
    responseToSaveAddress: (state, action) => {
      return {
        ...state,
        addressSaved: action?.payload,
      };
    },
    responseToFetchUserAddress: (state) => {
      return {
        ...state,
        alreadyHasAddress: true,
      };
    },
    responseToFetchAssignedUserDetails: (state, action) => {
      return {
        ...state,
        assignedUserDetails: action.payload,
      };
    },
    setCreateRoomDetails: (state, action) => {
      return {
        ...state,
        createRoomDetails: action?.payload,
      };
    },
    setRoomJoinDetails: (state, action) => {
      return {
        ...state,
        roomJoinDetails: action?.payload,
      };
    },
    requestToResetSecretSantaState: (state) => {
      return {
        ...state,
        roomCreated: false,
        roomJoined: false,
        isAddressSavedToUSerAccount: false,
        errorMsg: "",
      };
    },
    requestToRevealSantaInfo: (state) => {
      return {
        ...state,
      };
    },
    responseFromRevealSantaInfo: (state, action) => {
      return {
        ...state,
        roomSantaRevealed: action.payload,
      };
    },
  },
});

export default SecretSantaSlice.reducer;
export const {
  requestToCreateRoom,
  setCreateRoomDetails,
  requestToSaveAddress,
  responseToSaveAddress,
  requestToJoinRoom,
  responseToJoinRoom,
  requestToFailedJoinRoom,
  requestToFetchRoomInfo,
  responseToFetchRoomInfo,
  requestToAssignRoom,
  responseFromAssignRoom,
  responseToCreateRoom,
  setRoomJoinDetails,
  requestToFetchUserAddress,
  responseToFetchUserAddress,
  requestToFetchAssignedUserDetails,
  responseToFetchAssignedUserDetails,
  requestToAddNewAddressToUser,
  responseFromAddNewAddressToUser,
  requestToResetSecretSantaState,
  requestToRevealSantaInfo,
  responseFromRevealSantaInfo,
} = SecretSantaSlice.actions;
